import { useTranslation } from "react-i18next";
import formatPrice from "@/core/helpers/formatPrice";
import { BankCardIcon, CashIcon } from "@/shared/icons";

type Props = {
  cash: number;
  card: number;
};

export default function ShopUserBalance({ cash, card }: Props) {
  const { t } = useTranslation("shop");

  return (
    <div className="flex flex-col gap-[0.625rem]">
      <div className="flex gap-[0.875rem]">
        <CashIcon className="w-5.5 text-accent-solid" />
        <div className="flex flex-col text-15">
          <p className="font-medium text-accent-solid">{t("money.cash")}:</p>
          <p className="font-bold">{formatPrice(cash)} ₽</p>
        </div>
      </div>
      <div className="flex gap-[0.875rem]">
        <BankCardIcon className="w-5.5 text-accent-solid" />
        <div className="flex flex-col text-15">
          <p className="font-medium text-accent-solid">{t("money.card")}:</p>
          <p className="font-bold">{formatPrice(card)} ₽</p>
        </div>
      </div>
    </div>
  );
}
